import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthTokenRefreshService } from './auth-token-refresh.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService implements CanActivate {
  apiUrl = environment.apiurl;

  constructor(
    public router: Router,
    private tokenRefresh: AuthTokenRefreshService
  ) {}

  canActivate(): boolean | Observable<boolean> {
    if (this.isValidTokenStored()) {
      return true;
    }

    if (!localStorage.getItem('token')) {
      return this.failActivate();
    }

    return this.tokenRefresh.refreshToken().pipe(
      map(() => true),
      catchError(() => of(this.failActivate()))
    );
  }

  clearSessionAndRedirect(): void {
    localStorage.clear();
    this.router.navigate(['/']);
  }

  hasValidTokenStored(): boolean {
    return this.isValidTokenStored();
  }

  private failActivate(): false {
    this.clearSessionAndRedirect();
    return false;
  }

  private isValidTokenStored(): boolean {
    const token = localStorage.getItem('token');
    if (token === null) {
      return false;
    }

    const tokenExpiry = localStorage.getItem('tokenExpires');
    if (!tokenExpiry) {
      return false;
    }

    const expiryUnix = Number(tokenExpiry);
    if (!Number.isNaN(expiryUnix) && expiryUnix > 1_000_000_000) {
      return expiryUnix > Date.now() / 1000 + 30;
    }

    const expiryDate = new Date(tokenExpiry);
    return expiryDate > new Date();
  }
}
